import { render } from "./IotView.vue?vue&type=template&id=971be6d0&scoped=true"
import script from "./IotView.vue?vue&type=script&lang=js"
export * from "./IotView.vue?vue&type=script&lang=js"

import "./IotView.vue?vue&type=style&index=0&id=971be6d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-971be6d0"]])

export default __exports__